<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el" style="padding: 0.35rem;">
				<div class="top_tip">需要重复测试以提高测试准确性。判读测试结果时请遵循下表</div>
			</div>

			<div class="step_el" style="padding: 0.45rem;">
				<van-image width="100%" height="auto" lazy-load show-loading
					:src="require('@/assets/img/chinese/step_table.webp')" @click.stop.prevent="showBig">
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit"></div>
				<div style="padding: 0.4rem;">
					<ul>
						<li>
							应结合个人最近的接触史、病史以及是否存在与 COVID-19 一致的临床体征和症状来考虑结果。
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button type="primary" block round color="linear-gradient(to right, #a74af2, #5949f2)" @click="exit">
				下一步
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
	import {
		ImagePreview
	} from "vant";
	export default {
		components: {
			//
		},
		data() {
			return {
				imgList: [
					require('@/assets/img/chinese/step_table.webp'),
				]
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
		},
		created() {
			// this.$toast.loading({
			// 	duration: 0,
			// });
		},
		mounted() {
			//this.$toast.clear();
		},
		watch: {
			//
		},
		methods: {
			//回到主页
			exit() {
				this.$router.push({
					path: '/chinese/stepNight'
				});
			},
			//展示大图
			showBig(value) {
				let that = this;
				ImagePreview({
					images: that.imgList,
				});
			}
		},
		destroyed() {
			//
		}
	}
</script>
</script>

<style scoped>
	.container {
		/* position: absolute;
	height: 100%; */
		/* background-color: #fbfbfb; */
	}

	.top_tip {
		padding: 0.25rem 0.45rem;
		background-color: #ffcaca;
		font-size: 0.32rem;
		color: #720000;
		border-radius: 8px;
		border: 1px #720000 solid;
		font-weight: bold;
	}

	.step_box .step_el {
		background-color: #ffffff;
		margin-bottom: 0.32rem;
		border-radius: 0.32rem;
		box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
		overflow: hidden;
		position: relative;
		border: 1px solid #E9E9E9;
	}

	.step_box .step_el:last-child {
		margin-bottom: 0;
	}

	/* .step_box, .btn_box{background-color: #fbfbfb;} */
	.step_box {
		padding-bottom: 0.64rem !important;
	}

	/*步骤下说明文字*/
	.step_txt {
		padding: 0.533rem 0.64rem 0.427rem 0.64rem;
		color: #333333;
	}


	.countdown_box {
		padding: 0.2rem 0.5rem 0.3rem 0.5rem;
		text-align: center;
		color: #666666;
	}

	.countdown_box .count_btn {
		margin-top: 0.5rem;
		padding-top: 0.3rem;
		border-top: 1px solid #f8f8f8;
		color: #333333;
	}

	.step_box {
		position: relative;
		padding: 0.32rem 0.32rem 0 0.32rem;
	}

	.step_box img {
		width: 100%;
		height: auto;
	}

	.step_box .step_el {
		position: relative;
	}

	.step_box .step_el:last-child {
		padding-bottom: 0;
	}

	.step_box .step_el .tit {
		position: absolute;
		top: 0.32rem;
		left: 0.32rem;
		font-size: 0.533rem;
		color: #333333;
		font-weight: bold;
	}

	.btn_box {
		position: fixed;
		bottom: 0.667rem;
		width: 100%;
		padding: 0 0.9rem 0 0.9rem;
	}

	.btn_box img {
		width: 100%;
	}

	>>>.van-button {
		height: 1.2rem;
	}

	>>>.van-button__text {
		color: #ffffff;
		font-size: 0.48rem;
		font-weight: bold;
	}

	@media screen and (min-device-width : 768px) {
		.btn_box {
			position: relative;
			width: 100%;
			padding: 3rem 0.9rem 0 0.9rem;
		}
	}
</style>
